import Home from './renderers/home';
import Nav from './components/nav';
import Loader from './components/loader';
// import Scroll from './components/scroll';
import Animations from './components/animations';
import Tools from './components/tools';
import Rgpd from './components/rgpd';

import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

document.addEventListener('DOMContentLoaded', () => {
	// DOM loaded
    Loader.init();

    gsap.registerPlugin(ScrollTrigger);

    new Nav();
    if(document.body.classList.contains('home')) {
        new Home();
    }
    
    // if(Tools.getCookie('loader_played') !== 'true') {
    //     setTimeout(() => {
    //         Animations.init();
    //     }, 5100);
    // } else {
        Animations.init();
    // }

    new Rgpd();

    // Scroll.init();
});